import { Box, Card, CardContent, Typography } from '@mui/material';

export const AIOOutcomeErrorCard = () => {
  return (
    <Card
      elevation={1}
      sx={{
        borderRadius: 5,
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.02)',
        width: '100%',
        maxWidth: { xs: '100%', sm: 500, md: 666 },
        minHeight: 400,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <CardContent
        sx={{
          p: { xs: 3, sm: 4, md: 5 },
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 5,
          textAlign: 'center',
        }}
      >
        {/* Error Icon */}
        <Box
          sx={{
            width: 110,
            height: 110,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '50%',
            backgroundColor: '#FFEBEE',
            border: '3px solid #D32F2F',
          }}
        >
          <Typography
            sx={{
              fontSize: 72,
              color: '#D32F2F',
              fontWeight: 'bold',
              lineHeight: 1,
            }}
          >
            !
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
          <Typography
            sx={{
              color: '#D32F2F',
              fontSize: 32,
              fontFamily: 'DM Sans',
              fontWeight: '700',
              lineHeight: '38.40px',
              textAlign: 'center',
            }}
          >
            Missing Call Information
          </Typography>
          <Typography
            sx={{
              color: 'black',
              fontSize: 16,
              fontFamily: 'DM Sans',
              fontWeight: '500',
              lineHeight: '22.40px',
              textAlign: 'center',
              mb: 1,
            }}
          >
            Please ensure you have accessed this page through the correct link.
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};
